module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0028.jpg?v=1033a8c7";